import { Tag } from 'antd'

import Box from '~/core/Box'
import { TAG_STYLE } from '../../ActiveSlide/ActiveSlideTitle/TagLabel'

interface InactiveSaved3dSlideTagsPropsType {
    is2dDfmGenerating?: boolean
    hasGenerated2dDfmFailed?: boolean
    sourceType?: string | null
}

const InactiveSaved3dSlideTags = (props: InactiveSaved3dSlideTagsPropsType) => {
    const { hasGenerated2dDfmFailed, is2dDfmGenerating } = props

    let StatusTag

    if (is2dDfmGenerating) {
        StatusTag = () => (
            <Tag
                data-test-target="im-dfm-3d-slide-generating-tag"
                style={TAG_STYLE}
            >
                Generating 2D DFM
            </Tag>
        )
    }
    if (hasGenerated2dDfmFailed) {
        StatusTag = () => (
            <Tag
                color="red"
                data-test-target="im-dfm-3d-slide-error-tag"
                style={TAG_STYLE}
            >
                Error
            </Tag>
        )
    }

    if (!StatusTag) {
        return null
    }

    return (
        <Box justifyContent="end">
            <StatusTag />
        </Box>
    )
}

export default InactiveSaved3dSlideTags
